import { Component, OnInit } from '@angular/core';
import { Journal } from '../../models/journal.model';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-journal',
  templateUrl: './journal.component.html',
  styleUrls: ['./journal.component.css']
})
export class JournalComponent implements OnInit {

  entrees: Journal[] = [];

  constructor(private journalService: JournalService) { }

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.journalService.getAll().subscribe(data => {
      this.entrees = data;
    });
  }

  vider(): void {
    if (confirm("Vider tout le journal d'activité ? Cette action est irréversible.")) {
      this.journalService.vider().subscribe(() => this.charger());
    }
  }
}
